<div class="help-desk">
  <app-header></app-header>
  <div class="main-content">
    <router-outlet>
      <app-loader />
    </router-outlet>
  </div>
</div>
